export default __webpack_public_path__ + "ceb8e1e88223b74c11cd389b66a7ef3e.glb";